module.exports = __webpack_public_path__ + "img/sw_shitudo.90aaccb8.svg";